<template>
  <footer class="bg-[#000000] text-white text-center p-4 mt-auto">
    <p>&copy; Câmara Municipal de Mafra</p>
  </footer>
</template>

<script setup lang="ts"></script>